/**
 * Packs documents into a .zip, names unchanged, text stored as UTF-8. Images go in
 * under the same paths the documents use for them. The zip library is fetched
 * the first time something is exported.
 */
export async function zipDocuments(
  files: { name: string; text: string }[],
  images: { name: string; data: Uint8Array }[] = [],
): Promise<Uint8Array> {
  const { strToU8, zipSync } = await import("fflate");
  const entries: Record<string, Uint8Array | [Uint8Array, { level: 0 }]> = {};
  for (const file of files) entries[file.name] = strToU8(file.text);
  // Pictures are already compressed.
  for (const image of images) entries[image.name] = [image.data, { level: 0 }];
  return zipSync(entries, { level: 6 });
}
